/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IncidentStatusDto } from './incidentStatusDto.schema';

export const IReadOnlyListOfIncidentStatusDto = zod.array(zod.lazy(() => IncidentStatusDto));

export type IReadOnlyListOfIncidentStatusDto = zod.input<typeof IReadOnlyListOfIncidentStatusDto>;
export type IReadOnlyListOfIncidentStatusDtoOutput = zod.output<typeof IReadOnlyListOfIncidentStatusDto>;
